import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.tsx';
import { Botao, Campo, Card } from '../components/ui/index.tsx';

export default function Login() {
  const { usuario, carregando, entrar } = useAuth();
  const [identificador, setIdentificador] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  if (carregando) return null;
  if (usuario) return <Navigate to="/inicio" replace />;

  async function aoEnviar(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(identificador.trim(), senha);
    } catch (err) {
      // Mensagem única para usuário inexistente e senha errada: distinguir os
      // dois casos entrega ao atacante a lista de quem tem conta.
      setErro(err instanceof Error ? err.message : 'Não foi possível entrar.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="grid min-h-dvh place-items-center bg-[var(--bg)] px-5 py-10">
      <div className="w-full max-w-sm">
        <img
          src="/rondonbens-logo.png"
          alt="Rondonbens Proteção Veicular"
          className="mx-auto mb-8 h-8 w-auto dark:brightness-0 dark:invert"
        />

        <Card className="p-6 sm:p-8">
          <h1 className="text-xl font-semibold text-[var(--fg)]">Entrar no Hub</h1>
          <p className="mt-1 mb-7 text-sm text-[var(--muted)]">
            Entre com seu CPF ou o e-mail cadastrado pela sua regional.
          </p>

          <form onSubmit={aoEnviar} className="flex flex-col gap-5" noValidate>
            <Campo
              rotulo="CPF ou e-mail"
              type="text"
              name="identificador"
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              required
              value={identificador}
              onChange={(e) => setIdentificador(e.target.value)}
              placeholder="000.000.000-00"
            />

            <Campo
              rotulo="Senha"
              type="password"
              name="senha"
              autoComplete="current-password"
              required
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              placeholder="••••••••"
              erro={erro ?? undefined}
            />

            <Botao
              type="submit"
              variante="primario"
              tamanho="lg"
              larguraTotal
              carregando={enviando}
              className="mt-1"
            >
              Entrar
            </Botao>
          </form>
        </Card>

        <p className="mt-6 text-center text-xs text-[var(--faint)]">
          Esqueceu a senha? Fale com o gestor da sua regional.
        </p>
      </div>
    </div>
  );
}
